import * as React from 'react';
type Props = {
  className?: string;
};
export function HrSteamingBowl({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-hr-steaming-bowl"
      className={className}
    >
      <path
        d="M35.9819 21.0004H3.50488H3.20872C3.16268 20.9926 2.98459 21.0903 3.00107 21.3719C3.02285 21.744 3.90397 27.2642 7.68952 31.0894C7.68952 31.0894 12.3796 36.0181 18.8351 36C25.2906 35.9818 28.7735 34.4892 31.7933 31.6573C34.8131 28.8254 36.5247 24.3363 36.9414 21.9028C36.9414 21.9028 37.0576 21.2733 36.9628 21.1551C36.8908 21.0652 36.8498 21.0291 36.6611 21.0004H35.9819Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3341 31C16.6179 29.2358 18.3114 27.9596 20.176 28.0393C21.9158 28.1138 23.4039 29.351 23.6685 30.9923H27C26.9652 30.7294 26.4059 27.0704 22.9096 25.5779C20.7965 24.6757 18.8231 25.0674 18.2856 25.1927C15.8707 25.7558 14.1193 27.4538 13.3971 29.2541C13.1216 29.94 13.0303 30.5545 13 30.9935C14.1116 30.9959 15.2225 30.9976 16.3341 31Z"
        fill="currentColor"
      />
      <path
        d="M20 2C20 3.29882 19 3.29882 19 4.59764C19 5.89664 20 5.89664 20 7.19564C20 8.49497 19 8.49497 19 9.7943C19 11.0957 20 11.0957 20 12.3972C20 13.6986 19 13.6986 19 15"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M28 4C28 5.29882 27 5.29882 27 6.59764C27 7.89664 28 7.89664 28 9.19564C28 10.495 27 10.495 27 11.7943C27 13.0957 28 13.0957 28 14.3972C28 15.6986 27 15.6986 27 17"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M12 4C12 5.29882 11 5.29882 11 6.59764C11 7.89664 12 7.89664 12 9.19564C12 10.495 11 10.495 11 11.7943C11 13.0957 12 13.0957 12 14.3972C12 15.6986 11 15.6986 11 17"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
    </svg>
  );
}
